import { coursesApis } from '@shared/apis';
import {
  genericMutation,
  genericMutationWithId,
  genericQuery,
  genericQueryWithId,
  genericQueryWithParams,
} from './generics';

export const useUserCourses = genericQuery<coursesApis.GetUserCourses>(coursesApis.getUserCourses);

export const useCourse = genericQueryWithId<coursesApis.GetCourse>(coursesApis.getCourse);

export const useGetAllCourses = genericQuery<coursesApis.GetAllCourses>(coursesApis.getAllCourses);

export const useGetAllCoursesLite = genericQuery<coursesApis.GetAllCoursesLite>(
  coursesApis.getAllCoursesLite
);

export const useGetAllCoursesByMentor = genericQuery<coursesApis.GetCoursesByMentor>(
  coursesApis.getCoursesByMentor
);

export const useSoftDeleteCourse = genericMutationWithId<coursesApis.SoftDeleteCourse>(
  coursesApis.softDeleteCourse
);

export const useUploadCourseImage = genericMutationWithId<coursesApis.UploadCourseImage>(
  coursesApis.uploadCourseImage
);

export const useGetAdminCoursesOverview =
  genericQueryWithParams<coursesApis.GetAdminCoursesOverview>(coursesApis.getAdminCoursesOverview);

export const useGetAdminCourseInsights = genericQueryWithId<coursesApis.GetAdminCourseInsights>(
  coursesApis.getAdminCourseInsights
);

export const useAddCourse = genericMutation<coursesApis.AddCourseTyped>(coursesApis.addCourse);

export const useEditCourse = genericMutation<coursesApis.EditCourseTyped>(coursesApis.editCourse);

export const useGetAdminCoursesAssessment = genericQuery<coursesApis.GetAdminCoursesAssessment>(
  coursesApis.getAdminCoursesAssessment
);
